<template>
    <form autocomplete="off" novalidate @submit.prevent="update" method="post" style="max-width: 500px">
        <div>
            <h2>Реквизиты</h2>

            <q-field>
                <h-input stack-label="Полное наименование компании"
                         type="text"
                         v-model="paymentDetails.company_name"/>
            </q-field>
            <q-field>
                <q-select
                        v-model="paymentDetails.company_type"
                        :options="getCompanyType"
                        @change="update"
                        stack-label="Тип компании"
                />
            </q-field>
            <q-field>
                <h-input
                        v-if="showEdrpouField"
                        :stack-label="showEdrpouName"
                        type="text"
                        v-model="paymentDetails.edrpou"
                />
            </q-field>
            <q-field>
                <h-input
                        v-if="showInnField"
                        @input="duplicateInnValue"
                        :stack-label="showInnName"
                        type="text"
                        v-model="paymentDetails.inn"
                />
            </q-field>
            <q-field>
                <h-input stack-label="Адрес юридический"
                         type="text"
                         v-model="paymentDetails.legal_address"/>
            </q-field>
            <q-field>
                <h-input stack-label="Адрес фактический"
                         type="text"
                         v-model="paymentDetails.actual_address"/>
            </q-field>
            <q-field>
                <h-input stack-label="Должность руководителя"
                         type="text"
                         v-model="paymentDetails.user_position"/>
            </q-field>
            <q-field>
                <h-input stack-label="ФИО руководителя"
                         type="text"
                         v-model="paymentDetails.full_name"/>
            </q-field>
            <q-field>
                <h-input stack-label="IBAN"
                         type="text"
                         v-model="paymentDetails.iban"/>
            </q-field>
            <q-field>
                <h-input stack-label="Email для актов во «Вчасно»"
                         type="text"
                         v-model="paymentDetails.vchasno_email"/>
            </q-field>
        </div>

        <br>

        <q-field borderless label="Статус во Вчасно" stack-label>
            <template v-slot:control>
                <div class="self-center full-width no-outline">
                    {{ paymentDetails.is_active_vchasno.valueOf() }}
                </div>
            </template>
        </q-field>
        <br>
        <div v-if="paymentDetails.is_active_vchasno" class="row justify-left q-mt-md">
            <q-btn label="Обновить" type="submit" color="primary" class="q-mr-xs"/>
            <q-btn v-on:click="deactivateVchasno" label="Деактивировать Вчасно"
                   type="button" color="primary" class="justify-right q-mr-xs"/>
        </div>
        <div v-else class="row justify-left q-mt-md">
            <q-btn label="Обновить" type="submit" color="primary" class="q-mr-xs"/>
            <q-btn v-on:click="checkIsRegister" label="Активировать Вчасно"
                   type="button" color="primary" class="justify-right q-mr-xs"/>
        </div>
    </form>
</template>

<script>
import columnsValues from '@/HTable/columnsValues'
import { BarChart, HTable, HTh } from '@'

import HInput from '@/HInput'

import {
    date,
    QBtn,
    QCard,
    QCardMain,
    QCardTitle,
    QChip,
    QDatetime,
    QEditor,
    QField,
    QIcon,
    QInput,
    QItem,
    QItemMain,
    QItemSeparator,
    QItemSide,
    QModal,
    QSelect,
    QTable,
    QTableColumns,
    QTd,
    QTh,
    QTr,
} from 'quasar'
import {
  COMPANY_TYPE_BUSINESS,
  COMPANY_TYPE_BUSINESS_NDS,
  COMPANY_TYPE_INDIVIDUAL,
  COMPANY_TYPES_WITH_EDRPOU,
  COMPANY_TYPES_WITH_INN
} from "../../constants/companyTypes";

export default {
  name: 'ProjectRequisites',

  props: {
    requisites: {
      type: Object,
      required: true,
    },
  },

  components: {
    QField,
    QInput,
    QSelect,
    QChip,
    QDatetime,
    QBtn,
    QIcon,
    QModal,
    QCard,
    QCardTitle,
    QCardMain,
    QItem,
    QItemSide,
    QItemMain,
    QItemSeparator,
    QTable,
    QTableColumns,
    QTr,
    QTh,
    QTd,
    QEditor,
    date,
    HTable,
    HTh,
    HInput,
    BarChart,
  },

  data () {
    return {
      loading: false,
      paymentDetails: {},
    }
  },

  methods: {
    update () {
      this.loading = true
      this.paymentDetails.change_provider = false
      this.$http.post(`api/v1.0/projects/${ this.$route.params.id }/payments-data`, this.paymentDetails).
        then((response) => {
          this.paymentDetails = response.data
          this.loading = false
          this.$store.commit('project/setRequisites', { ...this.paymentDetails })

          this.$q.notify({ message: 'Успешно обновлено', type: 'positive' })
        }).
        catch((error) => {
          let response = error.response,
            data = response.data

          if (response.status === 422 && data.errors) {
            _.forIn(data.errors, (value, key) => {
              this.$q.notify({ message: value[0], type: 'negative' })
            })
          }
          else {
            this.$q.notify({ message: 'Произошла неизвестная ошибка при сохранении', type: 'negative' })
          }

          this.loading = false
        })
    },

    checkIsRegister () {
      this.$http.post(`api/v1.0/projects/${ this.$route.params.id }/checkVchasno`,
        { 'edrpou': this.paymentDetails.edrpou }).then((response) => {
        this.paymentDetails.is_active_vchasno = response.data.isRegistered
        if (this.paymentDetails.is_active_vchasno) {
          this.$q.notify({
            message: 'Проверенно, пользователь зарегистрирован во Вчасно',
            type: 'positive',
          })
        }
        else {
          this.$q.notify({
            message: 'Проверенно, пользователь не найден во Вчасно',
            type: 'negative',
          })
        }
      }).catch((error) => {
        this.$q.notify({ message: 'Произошла неизвестная ошибка при синхронизации', type: 'negative' })
      })
      this.update()
    },

    deactivateVchasno () {
      this.paymentDetails.is_active_vchasno = false
      this.update()
    },

    duplicateInnValue (value) {
      if (this.showEdrpouField) {
        return
      }

      this.paymentDetails.edrpou = value
    },
  },

  computed: {
    getCompanyType () {
      return columnsValues.userType
    },

    currentCompanyType () {
      return this.paymentDetails.company_type
    },

    showInnField () {
      return COMPANY_TYPES_WITH_INN.includes(this.currentCompanyType)
    },

    showEdrpouField () {
      return COMPANY_TYPES_WITH_EDRPOU.includes(this.currentCompanyType);
    },

    showInnName () {
      const companyTypesWithRnukpn = [COMPANY_TYPE_INDIVIDUAL, COMPANY_TYPE_BUSINESS];

      return companyTypesWithRnukpn.includes(this.currentCompanyType) ? 'РНУКПН (ИНН)' : 'ИНН'
    },

    showEdrpouName () {
      return this.currentCompanyType === COMPANY_TYPE_BUSINESS_NDS ? 'РНУКПН' : 'ЕГРПОУ'
    },
  },

  mounted () {
    this.paymentDetails = { ...this.requisites }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ProjectRequisites/ProjectRequisites.vue